import { Material, MeshBasicMaterial } from 'three';

import { LoadType } from '@paragon/contract-library';
import { assertExhaustiveSwitch } from '@paragon/utilities';

const dead = new MeshBasicMaterial({ transparent: true, opacity: 0.5, color: 0xaa44dd, depthTest: false });
const wind = new MeshBasicMaterial({ transparent: true, opacity: 0.5, color: 0xff1000, depthTest: false });
const liveRoof = new MeshBasicMaterial({ transparent: true, opacity: 0.5, color: 0x10ffff, depthTest: false });
const liveFloor = new MeshBasicMaterial({ transparent: true, opacity: 0.5, color: 0x1000ff, depthTest: false });
const defaultMaterial = new MeshBasicMaterial({ transparent: true, opacity: 0.5, color: 0xffffff, depthTest: false });

export const getLoadMaterial = (loadType: LoadType): Material => {
  switch (loadType) {
    case 'Dead': {
      return dead;
    }
    case 'Wind':
    case 'Tornado': {
      return wind;
    }
    case 'LiveRoof':
    case 'Person': {
      return liveRoof;
    }
    case 'LiveFloor': {
      return liveFloor;
    }
    case 'Rain':
    case 'Snow':
    case 'Drag':
    case 'Unknown':
    case 'Seismic': {
      return defaultMaterial;
    }
    default:
      assertExhaustiveSwitch(loadType, 'Unrecognized load type');
  }
};
